import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { MiniSheet } from '../../MiniSheet/index.js'
import { IconButton } from '../../IconButton/index.js'
import { FORMAT_ELEMENT_COMMAND } from 'lexical'
import { useState } from 'react'

export const SelectTextAlign = ({ align, disabled, size }) => {
  const [editor] = useLexicalComposerContext()
  const [menuOpen, setMenuOpen] = useState(false)

  return (
    <MiniSheet
      onOpen={() => setMenuOpen(true)}
      onClose={() => setMenuOpen(false)}
    >
      <MiniSheet.Trigger>
        <IconButton
          tooltip={menuOpen ? null : 'Align text'}
          size={size}
          icon={align ? (`aligned-text-${align}` as any) : 'aligned-text-left'}
          trailChevron="down"
          disabled={disabled}
        />
      </MiniSheet.Trigger>
      <MiniSheet.Items>
        <MiniSheet.Item
          size="small"
          icon="aligned-text-left"
          tooltip="Align left"
          keyHint="Cmd+Shift+L"
          keyHintVisualOnly
          onClick={() => {
            editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, 'left')
          }}
          toggled={align === 'left'}
        />
        <MiniSheet.Item
          size="small"
          icon="aligned-text-center"
          tooltip="Align center"
          keyHint="Cmd+Shift+E"
          keyHintVisualOnly
          onClick={() => {
            editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, 'center')
          }}
          toggled={align === 'center'}
        />
        <MiniSheet.Item
          size="small"
          icon="aligned-text-right"
          tooltip="Align right"
          keyHint="Cmd+Shift+R"
          keyHintVisualOnly
          onClick={() => {
            editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, 'right')
          }}
          toggled={align === 'right'}
        />
      </MiniSheet.Items>
    </MiniSheet>
  )
}
